export interface IPresentation {
  ocorrenciaNo: number;
  codigo: any;
  titulo: any;
  habilitado: boolean;
}
